import Reflux from 'reflux'

export default Reflux.createActions(['splitterResize','dividedBoxDidMount',
                                    'mainMenuToggle','verticalSplitterResize',
                                    'getSubFieldGroupMaxWidth','setSubFieldGroupMaxWidth','visibleFalseToTrue',
                                'groupSlide','groupRefersh']);


// WEBPACK FOOTER //
// ./src/actions/ResizeActions.js